import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
export function HeroSection() {
  return <section id="inicio" className="relative min-h-screen flex items-center justify-center overflow-hidden bg-brand-navy pt-20" data-id="element-265">
      {/* Background Elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none" data-id="element-266">
        <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(circle_at_top_right,_var(--tw-gradient-stops))] from-brand-royal/40 via-brand-navy to-brand-navy" data-id="element-267"></div>

        {/* Animated floating shapes */}
        <motion.div animate={{
        y: [0, -20, 0],
        x: [0, 10, 0]
      }} transition={{
        duration: 5,
        repeat: Infinity,
        ease: 'easeInOut'
      }} className="absolute top-1/4 left-1/4 w-64 h-64 bg-brand-royal/20 rounded-full blur-3xl" data-id="element-268" />
        <motion.div animate={{
        y: [0, 30, 0],
        x: [0, -20, 0]
      }} transition={{
        duration: 7,
        repeat: Infinity,
        ease: 'easeInOut',
        delay: 1
      }} className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-brand-crimson/10 rounded-full blur-3xl" data-id="element-269" />

        {/* Decorative dots */}
        <motion.div animate={{
        scale: [1, 1.2, 1],
        opacity: [0.5, 1, 0.5]
      }} transition={{
        duration: 4,
        repeat: Infinity
      }} className="absolute top-1/3 right-1/3 w-4 h-4 bg-brand-gold rounded-full" data-id="element-270" />
        <motion.div animate={{
        scale: [1, 1.5, 1],
        opacity: [0.3, 0.8, 0.3]
      }} transition={{
        duration: 6,
        repeat: Infinity,
        delay: 2
      }} className="absolute bottom-1/3 left-1/3 w-6 h-6 bg-brand-lightBlue rounded-full" data-id="element-271" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col items-center text-center" data-id="element-272">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="max-w-4xl mx-auto flex flex-col items-center" data-id="element-273">
          <div className="bg-white/10 backdrop-blur-sm border border-white/20 px-4 py-1.5 rounded-full mb-8 inline-flex items-center gap-2" data-id="element-274">
            <span className="w-2 h-2 rounded-full bg-brand-gold animate-pulse" data-id="element-275"></span>
            <span className="text-white/90 text-sm font-medium tracking-wide uppercase" data-id="element-276">
              Fundación sin fines de lucro
            </span>
          </div>

          <h1 className="text-5xl md:text-7xl font-heading font-bold text-white mb-6 leading-tight" data-id="element-277">
            Uniendo Fuerzas por{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-brand-gold to-yellow-200" data-id="element-278">
              Ecuador
            </span>
          </h1>

          <p className="text-lg md:text-2xl text-white/80 mb-10 max-w-2xl font-light leading-relaxed" data-id="element-279">
            Fortalecemos organizaciones sin fines de lucro a través de apoyo
            técnico, transformación digital, capacitación y articulación
            colaborativa con empresas, academia y sector público.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto" data-id="element-280">
            <a href="#como-funciona" className="group flex items-center justify-center gap-2 bg-brand-gold hover:bg-yellow-400 text-brand-navy font-heading font-semibold px-8 py-4 rounded-full transition-all duration-300 transform hover:-translate-y-1 shadow-lg hover:shadow-brand-gold/25 text-lg" data-id="element-281">
              Conoce Más
              <ArrowRightIcon className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-282" />
            </a>
            <a href="#unete" className="flex items-center justify-center gap-2 bg-white/10 hover:bg-white/20 text-white border border-white/30 font-heading font-semibold px-8 py-4 rounded-full transition-all duration-300 backdrop-blur-sm text-lg" data-id="element-283">
              Únete a la Red
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}